<template>
    <ManualSection :header="header" :open="open" :state="state" @click="$emit('click')">
        <template v-slot:comment>
            <p v-if="!uploaded" class="cmnt">Вы можете отправить подписанное заявление на вступление почтой или принести в офис.</p>
            <p v-if="!uploaded" class="cmnt">Распечатайте заявление на вступление, подпишите его, отсканируйте/сфотографируйте и загрузите полученное изображение.</p>
            <p class="cmnt" v-if="uploaded">Скан заявления загружен.</p>
        </template>

        <RequestScanUpload commentPosition="none" :showUploadedComment="false" />
    </ManualSection>
</template>

<script>
import RequestScanUpload from './requestScanUpload.vue'
import ManualSection from '@/components/ManualSection.vue'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        RequestScanUpload,
        ManualSection
    },
    computed: {
        uploaded() {
            return this.$store.getters.getUserData.memberInfo?.isRequestScanUploaded;
        },
        state() {
            return this.uploaded ? 'success' : 'warning';
        },
    }
}
</script>
